import { getToken } from '@/libs/util.token'
export default ({ request }) => ({
  SYS_UPLOAD(file) {
    let formData = new FormData()
    formData.append('file', file)
    formData.append('expirationsec', 0)
    formData.append('fileproperty', 'publicfiles')
    return request({
      url: '/oss/ossUploadReturnUrlAndFileId',
      method: 'post',
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: getToken() || ''
      },
      data: formData,
      sign: false
    })
  }
})
